import { TituloAbaService } from "./../titulo-aba/titulo-aba.service";
import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { environment } from "../../../environments/environment";
SwiperCore.use([Autoplay, Pagination, Navigation]);
import SwiperCore, {
  Autoplay,
  Pagination,
  Navigation,
  SwiperOptions,
} from "swiper";
import { SwiperComponent } from "swiper/angular";
import { ActivatedRoute } from "@angular/router";
import { CaixaTemService } from "./providers/caixa-tem.service";
import { CardModel } from "src/app/shared/models/card.model";
import { Faq } from "src/app/shared/models/faq.model";
import { configCarrossel } from "src/app/shared/utils/carouselConfig";
@Component({
  selector: "app-caixa-tem",
  templateUrl: "./caixa-tem.component.html",
  styleUrl: "./caixa-tem.component.scss",
  encapsulation: ViewEncapsulation.None,
  providers: [CaixaTemService],
})
export class CaixaTemComponent implements OnInit {
  public env = environment;
  carrosselIndex = 0;
  @ViewChild("mySwiper", { static: false }) mySwiper!: SwiperComponent;

  myConfig: SwiperOptions["breakpoints"] = configCarrossel;


  cards: CardModel[] = [];
  celHabilita: CardModel[] = [];
  celIndetifica: CardModel[] = [];
  faqArray: Faq[] = [];

  constructor(
    private tituloAbaService: TituloAbaService,
    private route: ActivatedRoute,
    private caixatemService: CaixaTemService
  ) {
    this.cards = caixatemService.getCards();
    this.celHabilita = caixatemService.getCardsCelHabilita();
    this.celIndetifica = caixatemService.getCardsCelIndentifica();
    this.faqArray = caixatemService.getFaqArray();
  }

  resetSwiper() {
    if (this.mySwiper) {
      this.mySwiper.swiperRef.slideTo(0);
    }
  }

  changeCaruselIndex(index: number) {
    this.carrosselIndex = index;

    this.resetSwiper();
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);

    this.tituloAbaService.setTitle("CAIXA Tem");
    this.tituloAbaService.setMeta(
      "description",
      "Empreendedores MEIs que possuem a conta CAIXA Tem podem começar a vender com a azulzinha, a maquininha de cartões da CAIXA. Aproveite essa oportunidade!"
    );
  }
}
